import React from 'react';
import { string, node } from 'prop-types';

import HelpButton from '../../HelpButton';

import styles from './infoRow.module.css';

const InfoRow = ({
  title, content, tooltipContent, dataCy
}) => (
  <>
    <div className={styles.header} data-cy={dataCy}>
      {title}
      {tooltipContent && (<>&nbsp;<HelpButton content={tooltipContent} /></>)}
    </div>
    <div className={styles.content}>{content}</div>
  </>
);

InfoRow.propTypes = {
  title: string.isRequired,
  content: node.isRequired,
  tooltipContent: string,
  dataCy: string
};

InfoRow.defaultProps = {
  dataCy: null,
  tooltipContent: null
};

export default InfoRow;
